export default __webpack_public_path__ + "static/media/vsp-04186.ece0f830.jpg";